<mat-form-field>
    <mat-label>{{resources.TimePeriod}} (YYYY-MM)</mat-label>
    <input matInput [matDatepicker]="dp" placeholder="{{resources.TimePeriod}} (YYYY-MM)" [formControl]="date">
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, dp)" panelClass="cal-month-picker">
    </mat-datepicker>
</mat-form-field>